import { ComposedChart, Bar, Line, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { Target } from 'lucide-react';
import { formatCurrency } from '@utils/formatters';
import { formatCompact } from './dashboardHelpers';
import ChartTooltip from './ChartTooltip';

const DashboardCashFlow = ({ projectionChartData, currentBalance }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-semibold text-gray-900 dark:text-white">Projeção de Fluxo de Caixa</h3>
          <p className="text-xs text-gray-400 mt-0.5">
            Próximos 6 meses baseado em recorrências e parcelamentos
          </p>
        </div>
        {currentBalance != null && (
          <span className="text-xs text-primary-600 font-medium bg-primary-50 dark:bg-primary-900/20 px-2 py-0.5 rounded-full">
            Saldo atual: {formatCompact(currentBalance)}
          </span>
        )}
      </div>
      {projectionChartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={200}>
          <ComposedChart data={projectionChartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" className="dark:stroke-gray-700" />
            <XAxis dataKey="label" stroke="#9ca3af" fontSize={11} />
            <YAxis tickFormatter={v => `${(v/1000).toFixed(0)}k`} stroke="#9ca3af" fontSize={11} width={40} />
            <Tooltip content={<ChartTooltip formatter={formatCurrency} />} />
            <Bar dataKey="projectedIncome" name="Receitas" fill="#22c55e" opacity={0.8} radius={[4,4,0,0]} />
            <Bar dataKey="projectedExpense" name="Despesas" fill="#ef4444" opacity={0.8} radius={[4,4,0,0]} />
            <Line type="monotone" dataKey="projectedBalance" name="Saldo Projetado"
              stroke="#0ea5e9" strokeWidth={2.5} dot={{ fill: '#0ea5e9', r: 4, strokeWidth: 0 }} />
          </ComposedChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-48 flex flex-col items-center justify-center text-gray-400 gap-2">
          <Target size={32} className="opacity-40" />
          <p className="text-sm">Adicione recorrências para ver a projeção</p>
        </div>
      )}
    </div>
  );
};

export default DashboardCashFlow;
